import { IDeeplTranslationRequest, IDeeplTranslationResponse } from 'PyzShopUi/scripts/shop-ui/interfaces';
import axios, { AxiosResponse } from 'axios';

const DEEPL_TRANSLATION_URL: string = '/ajax/deepl-translation';
export interface IDeeplTranslationService {
    translate(request: IDeeplTranslationRequest): Promise<IDeeplTranslationResponse>;
}

class DeeplTranslationService implements IDeeplTranslationService {
    private apiUrl: string = DEEPL_TRANSLATION_URL;

    public translate = async(request: IDeeplTranslationRequest): Promise<IDeeplTranslationResponse> => {
        const dataResponse: AxiosResponse<IDeeplTranslationResponse> = await axios.post(this.apiUrl, request);

        return dataResponse.data;
    };
}

export const deeplTranslationService: IDeeplTranslationService = new DeeplTranslationService();
